import './services.css'
import React from 'react'
import { useState } from 'react'

import Header from '../components/shared/header'
import ServiceCard from '../components/pages/services/service-card'
import PageTitle from '../components/basic/page-title'
import Steps from '../components/pages/services/steps'
import Button from '../components/basic/button'


const Services = () => {

    const [active, setActive] = useState('false');

    const handleSelectService = (event) => {
        document
            .querySelectorAll('.service-card')
            .forEach(card => card.classList.remove('selected'));

        event.currentTarget.classList.add('selected');

        setActive('true');
    };

    return (

        <div className="screen-main">

            <Steps Step="1" />

            <Header leftIcon="arrowLeft" label="Agenda" rightIcon="bell" action="/establishment" />

            <PageTitle Title='Escolha um serviço' Description='Selecione o procedimento desejado' />

            <div className="services-content">

                <p className='app-sub-title category'>Masculino</p>
                <div className="services-grid">
                    <ServiceCard Action={handleSelectService} Icon="cortemasc" Label='Corte Masculino' Time='45 min' Price='R$ 30,00' />
                    <ServiceCard Action={handleSelectService} Icon="barba" Label='Barba' Time='45 min' Price='R$ 15,00' />
                    <ServiceCard Action={handleSelectService} Icon="cortemascbarba" Label='Corte Masc. + Barba' Time='45 min' Price='R$ 40,00' />
                    <ServiceCard Action={handleSelectService} Icon="cortemaq" Label='Corte com máquina' Time='15 min' Price='R$ 35,00' />
                    <ServiceCard Action={handleSelectService} Icon="corteinf" Label='Corte infantil' Time='50 min' Price='R$ 50,00' />
                    <ServiceCard Action={handleSelectService} Icon="pezinho" Label='Pezinho' Time='15 min' Price='R$ 20,00' />
                </div>

                <p className='app-sub-title category'>Feminino</p>
                <div className="services-grid">
                    <ServiceCard Action={handleSelectService} Icon="cortefem" Label='Corte pontas' Time='20 min' Price='R$ 20,00' />
                    <ServiceCard Action={handleSelectService} Icon="pintura" Label='Pintura' Time='45 min' Price='R$ 30,00' />
                    <ServiceCard Action={handleSelectService} Icon="escova" Label='Escova' Time='20 min' Price='R$ 20,00' />
                    <ServiceCard Action={handleSelectService} Icon="sobrancelha" Label='Sobranchelha' Time='45 min' Price='R$ 30,00' />
                </div>

                <div className='continue-button'>
                    <Button Active={active} Label='Continuar' Icon='calendar' Action='/professionals' Direction='Next' />
                </div>

            </div>
        </div>

    )
}

export default Services